import React, { FC } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Tag } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";

import CommonService from "../../../../services/common.service";
import { ILayoutRibbon } from "../../../../models/layout-ribbon.model";
import { currencyFormat } from "../../../../services/constants";

const getOptions = (data: any[]): Highcharts.Options => {
  return {
    colors: [
      "#2b908f",
      "#90ee7e",
      "#f45b5b",
      "#7798BF",
      "#aaeeee",
      "#ff0066",
      "#eeaaee",
      "#55BF3B",
      "#DF5353",
      "#7798BF",
      "#aaeeee",
    ],
    chart: {
      borderWidth: 0,
      type: "area",
      margin: [4, 2, 0, 2],
      height: 70,
      width: 130,
      style: {
        overflow: "visible",
      },
      backgroundColor: "#11101d",
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      labels: {
        enabled: false,
      },
      title: {
        text: null,
      },
      startOnTick: false,
      endOnTick: false,
      tickPositions: [],
    },
    yAxis: {
      endOnTick: false,
      startOnTick: false,
      labels: {
        enabled: false,
      },
      title: {
        text: null,
      },
      tickPositions: [0],
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      borderWidth: 1,
      hideDelay: 0,
      shared: true,
      padding: 4,
      borderRadius: 3,
    },
    plotOptions: {
      series: {
        animation: false,
        lineWidth: 1,
        shadow: false,
        states: {
          hover: {
            lineWidth: 1,
          },
        },
        marker: {
          radius: 3,
          states: {
            hover: {
              radius: 2,
            },
          },
        },
      },
      column: {
        negativeColor: "#910000",
        borderColor: "silver",
      },
    },
    series: [
      {
        data,
        name: "Value",
        type: "line",
      },
    ],
  };
};

interface IProps {
  item: ILayoutRibbon;
  isIndex?: boolean;
}

const InstrumentsMarqueeItem: FC<IProps> = ({ item, isIndex }) => {
  return (
    <Tag key={item?.idInstrument}>
      <div
        className={`d-flex flex-column custom-tag mr-1 cursor-pointer`}
        key={item?.idInstrument}
      >
        <span className="fs-14">{item?.name}</span>
        <span className="fs-14">
          {isIndex ? CommonService.toLocalNum(item?.lastTradePriceOnly, {
            maximumFractionDigits: 3,
          }) :
            CommonService.toLocalNum(item?.lastTradePriceOnly, {
              ...currencyFormat,
              maximumFractionDigits: 3,
            })}
        </span>
        <div className="d-flex align-items-start justify-content-start pb-0_5">
          <div
            className="d-flex flex-column justify-content-between mr-0_5"
            style={{ lineHeight: "18px" }}
          >
            <span
              className={`fs-22 ${item?.changeinPercent < 0
                ? "red"
                : item?.change === 0
                  ? "orange"
                  : "green"
                }`}
            >
              {CommonService.toLocalNum(item?.changeinPercent, {
                maximumFractionDigits: 3,
              })}
              %
            </span>
            <span
              className={`fw-500 ${item?.change < 0
                ? "red"
                : item?.change === 0
                  ? "orange"
                  : "green"
                }`}
            >
              {CommonService.toLocalNum(item?.change, {
                maximumFractionDigits: 3,
              })}
            </span>
            <span>{item?.ticker}</span>
            <span className="fs-11">
              <ClockCircleOutlined className="mr-0_25" />
              {item?.lastTradeTime}
            </span>
          </div>
          <HighchartsReact
            highcharts={Highcharts}
            options={getOptions(item?.lastPrices)}
            constructorType="chart"
          />
        </div>
      </div>
    </Tag>
  );
};

export default InstrumentsMarqueeItem;
